<template>
  <div class="timeframe-group">
    <div class="left-timeframe-group">
      <div class="timeframe-visit-container">
        <div class="left-timeframe-visit-container">
          <div class="left-switch-timeframe-visit-container">
            <div class="switch-visit">
              <input id="s-visit" type="checkbox" class="switch" v-model="switchValueVisit" @change="buildSwitchValueVisit()" />
            </div>
            <div class="text-visit">Visit น้อยกว่า</div>
          </div>
          <div class="left-input-timeframe-visit-container">
            <div class="input-visit">
              <input
                :disabled="!switchValueVisit"
                type="text"
                v-model="formattedValueVisit"
                @input="onInput($event, 'visit')"
                @blur="formatNumberNonDigits('visit')"
                @focus="removeFormatting('visit')"
              />
            </div>
            <div class="text-input-visit">ครั้ง</div>
          </div>
        </div>
      </div>
      <div class="timeframe-total-container">
        <div class="left-timeframe-total-container">
          <div class="left-switch-timeframe-total-container">
            <div class="switch-total">
              <input id="s-total" type="checkbox" class="switch" v-model="switchValueTotal" @change="buildSwitchValueTotal()" />
            </div>
            <div class="text-total">Total Spending น้อยกว่า</div>
          </div>
          <div class="left-input-timeframe-total-container">
            <div class="input-total">
              <input
                :disabled="!switchValueTotal"
                type="text"
                v-model="formattedValueTotal"
                @input="onInput($event, 'total')"
                @blur="formatNumber('total')"
                @focus="removeFormatting('total')"
              />
            </div>
            <div class="text-input-total">บาท</div>
          </div>
        </div>
      </div>
      <div class="timeframe-avg-container">
        <div class="left-timeframe-avg-container">
          <div class="left-switch-timeframe-avg-container">
            <div class="switch-avg">
              <input id="s-avg" type="checkbox" class="switch" v-model="switchValueAVG" @change="buildSwitchValueAVG()" />
            </div>
            <div class="text-avg">Average Spending น้อยกว่า</div>
          </div>
          <div class="left-input-timeframe-avg-container">
            <div class="input-avg">
              <input
                :disabled="!switchValueAVG"
                type="text"
                v-model="formattedValueAVG"
                @input="onInput($event, 'avg')"
                @blur="formatNumber('avg')"
                @focus="removeFormatting('avg')"
              />
            </div>
            <div class="text-input-avg">บาท</div>
          </div>
        </div>
      </div>
    </div>
    <div class="divider" />
    <div class="right-timeframe-group">
      <div class="right-timeframe-container">
        <div class="right-top-timeframe-container">
          <div class="right-switch-timeframe-container">
            <div class="switch">
              <input
                :disabled="!switchValueVisit && !switchValueTotal && !switchValueAVG"
                id="s-timeframe"
                type="checkbox"
                class="switch"
                v-model="switchValueTimeFrame"
                @change="buildSwitchValueTimeFrame()"
              />
            </div>
            <div class="text">Timeframe</div>
          </div>
          <div v-if="switchValueTimeFrame" class="right-dropdown-timeframe-container">
            <!-- <div class="dropdown">[กำหนดค่าเอง]</div> -->
          </div>
        </div>
        <div v-if="switchValueTimeFrame" class="right-bottom-timeframe-container">
          <div class="right-text-timeframe-container">
            <div class="text">ย้อนหลัง</div>
          </div>
          <div class="right-after-timeframe-container">
            <div class="input">
              <input
                type="text"
                v-model="formattedValueTimeFrame"
                @input="onInput($event, 'timeframe')"
                @blur="formatNumberNonDigits('timeframe')"
                @focus="removeFormatting('timeframe')"
              />
            </div>
            <div class="dropdown">
              <v-select v-model="timeframeSelect" :options="dropDownTimeframe" :clearable="false" :searchable="false"></v-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onBeforeMount, ref, Ref, markRaw } from 'vue';

const switchValueVisit: Ref<boolean> = ref(false);
const switchValueTotal: Ref<boolean> = ref(false);
const switchValueAVG: Ref<boolean> = ref(false);
const switchValueTimeFrame: Ref<boolean> = ref(false);

const valueVisit = ref<number | null>(null);
const formattedValueVisit = ref<string>('');
const valueTotal = ref<number | null>(null);
const formattedValueTotal = ref<string>('');
const valueAVG = ref<number | null>(null);
const formattedValueAVG = ref<string>('');
const valueTimeFrame = ref<number | null>(null);
const formattedValueTimeFrame = ref<string>('');

const dropDownTimeframe = ref<any[]>([
  { label: 'วัน', id: 0 },
  { label: 'เดือน', id: 1 },
  { label: 'ปี', id: 2 },
]);
const timeframeSelect = ref<any>({ label: 'วัน', id: 0 });

function formatNumber(type: string) {
  switch (type) {
    case 'visit':
      if (valueVisit.value !== null) {
        formattedValueVisit.value = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(valueVisit.value);
      }
      break;
    case 'total':
      if (valueTotal.value !== null) {
        formattedValueTotal.value = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(valueTotal.value);
      }
      break;
    case 'avg':
      if (valueAVG.value !== null) {
        formattedValueAVG.value = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(valueAVG.value);
      }
      break;
    case 'timeframe':
      if (valueTimeFrame.value !== null) {
        formattedValueTimeFrame.value = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(valueTimeFrame.value);
      }
      break;
    default:
      break;
  }
}
function formatNumberNonDigits(type: string) {
  switch (type) {
    case 'visit':
      if (valueVisit.value !== null) {
        formattedValueVisit.value = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(valueVisit.value);
      }
      break;
    case 'total':
      if (valueTotal.value !== null) {
        formattedValueTotal.value = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(valueTotal.value);
      }
      break;
    case 'avg':
      if (valueAVG.value !== null) {
        formattedValueAVG.value = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(valueAVG.value);
      }
      break;
    case 'timeframe':
      if (valueTimeFrame.value !== null) {
        formattedValueTimeFrame.value = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(valueTimeFrame.value);
      }
      break;
    default:
      break;
  }
}
function removeFormatting(type: string) {
  switch (type) {
    case 'visit':
      if (valueVisit.value !== null) {
        formattedValueVisit.value = valueVisit.value.toString();
      }
      break;
    case 'total':
      if (valueTotal.value !== null) {
        formattedValueTotal.value = valueTotal.value.toString();
      }
      break;
    case 'avg':
      if (valueAVG.value !== null) {
        formattedValueAVG.value = valueAVG.value.toString();
      }
      break;
    case 'timeframe':
      if (valueTimeFrame.value !== null) {
        formattedValueTimeFrame.value = valueTimeFrame.value.toString();
      }
      break;
    default:
      break;
  }
}

function onInput(event: Event, type: string) {
  const input = event.target as HTMLInputElement;
  let rawValue = input.value.replace(/,/g, '');

  // Remove any non-numeric characters except for the decimal point
  rawValue = rawValue.replace(/[^0-9.]/g, '');

  // Handle multiple decimal points by allowing only the first one
  const decimalIndex = rawValue.indexOf('.');
  if (decimalIndex !== -1) {
    rawValue = rawValue.slice(0, decimalIndex + 1) + rawValue.slice(decimalIndex + 1).replace(/\./g, '');
  }

  switch (type) {
    case 'visit':
      if (!isNaN(parseFloat(rawValue))) {
        valueVisit.value = parseFloat(rawValue);
        formattedValueVisit.value = rawValue;
      } else {
        formattedValueVisit.value = '';
      }
      break;
    case 'total':
      if (!isNaN(parseFloat(rawValue))) {
        valueTotal.value = parseFloat(rawValue);
        formattedValueTotal.value = rawValue;
      } else {
        formattedValueTotal.value = '';
      }
      break;
    case 'avg':
      if (!isNaN(parseFloat(rawValue))) {
        valueAVG.value = parseFloat(rawValue);
        formattedValueAVG.value = rawValue;
      } else {
        formattedValueAVG.value = '';
      }
      break;
    case 'timeframe':
      if (!isNaN(parseFloat(rawValue))) {
        valueTimeFrame.value = parseFloat(rawValue);
        formattedValueTimeFrame.value = rawValue;
      } else {
        formattedValueTimeFrame.value = '';
      }
      break;
    default:
      break;
  }
}
function buildSwitchCheckAll() {
  if (!switchValueVisit.value && !switchValueTotal.value && !switchValueAVG.value) {
    switchValueTimeFrame.value = false;
  } else {
    switchValueTimeFrame.value = true;
  }
}
function buildSwitchValueVisit() {
  if (switchValueVisit.value == false) {
    formattedValueVisit.value = '';
    valueVisit.value = null;
  }
  buildSwitchCheckAll();
}
function buildSwitchValueTotal() {
  if (switchValueTotal.value == false) {
    formattedValueTotal.value = '';
    valueTotal.value = null;
  }
  buildSwitchCheckAll();
}
function buildSwitchValueAVG() {
  if (switchValueAVG.value == false) {
    formattedValueAVG.value = '';
    valueAVG.value = null;
  }
  buildSwitchCheckAll();
}
function buildSwitchValueTimeFrame() {}
</script>

<style lang="scss" scoped>
input {
  //styleName: Text Reg 16;
  font-family: Prompt;
  font-size: 16px;
  font-weight: 400;
  line-height: 24.19px;
  text-align: left;

  color: #2d2d2d;
  margin: 0;
  display: block;
  width: 100px;
  padding: 8px 16px 8px 16px;
  line-height: 1;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #e2e2e2;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 10px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  letter-spacing: 0.031rem;
  &:focus {
    outline: 0px solid transparent;
  }
  &:disabled {
    background-color: #f0f0f0;
    color: #a0a0a0;
    cursor: not-allowed;
    border: 1px solid #ccc;
  }
}
//
input[type='checkbox'].switch {
  --active: #6bb84c;
  --active-inner: #fff;
  --focus: 2px #6bb84c30;
  --border: rgba(0, 0, 0, 0.25);
  --border-hover: #6bb84c;
  --background: #fff;
  --disabled: #f6f8ff;
  --disabled-inner: #e1e6f9;
  -webkit-appearance: none;
  -moz-appearance: none;
  height: 21px;
  outline: none;
  display: inline-block;
  vertical-align: top;
  position: relative;
  margin: 0;
  cursor: pointer;
  border: 1px solid var(--bc, var(--border));
  background: var(--b, var(--background));
  transition: background 0.3s, border-color 0.3s, box-shadow 0.2s;
  &:after {
    content: '';
    display: block;
    left: 0;
    top: 0;
    position: absolute;
    transition: transform var(--d-t, 0.3s) var(--d-t-e, ease), opacity var(--d-o, 0.2s);
  }
  &:checked {
    --b: var(--active);
    --bc: var(--active);
    --d-o: 0.3s;
    --d-t: 0.6s;
    --d-t-e: cubic-bezier(0.2, 0.85, 0.32, 1.2);
  }
  &:disabled {
    --b: var(--disabled);
    cursor: not-allowed;
    opacity: 0.9;
    &:checked {
      --b: var(--disabled-inner);
      --bc: var(--border);
    }
    & + label {
      cursor: not-allowed;
    }
  }
  &:hover {
    &:not(:checked) {
      &:not(:disabled) {
        --bc: var(--border-hover);
      }
    }
  }
  &:focus {
    box-shadow: 0 0 0 var(--focus);
  }
  & + label {
    font-size: 14px;
    line-height: 21px;
    display: inline-block;
    vertical-align: top;
    cursor: pointer;
    margin-left: 4px;
  }
}
input[type='checkbox'].switch {
  width: 38px;
  border-radius: 11px;
  &:after {
    left: 2px;
    top: 2px;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    background: var(--ab, var(--border));
    transform: translateX(var(--x, 0));
  }
  &:checked {
    --ab: var(--active-inner);
    --x: 17px;
  }
  &:disabled {
    &:not(:checked) {
      &:after {
        opacity: 0.6;
      }
    }
  }
}
.timeframe-group {
  margin-top: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 26px;
  gap: 56px;
  border-radius: 10px;
  border: 1px solid rgba(226, 226, 226, 1);
  height: 300px;
  .left-timeframe-group {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 50%;
    .timeframe-visit-container {
      display: flex;
      width: 100%;
      height: 40px;
      .left-timeframe-visit-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        .left-switch-timeframe-visit-container {
          display: flex;
          .switch-visit {
          }
          .text-visit {
            margin-left: 1.5rem;
            //styleName: Text Reg 16;
            font-family: Prompt;
            font-size: 16px;
            font-weight: 400;
            line-height: 24.19px;
            text-align: left;
          }
        }
        .left-input-timeframe-visit-container {
          display: flex;
          align-items: center;
          .input-visit {
          }
          .text-input-visit {
            margin-left: 1.5rem;
            //styleName: Text Reg 16;
            font-family: Prompt;
            font-size: 16px;
            font-weight: 400;
            line-height: 24.19px;
            text-align: left;
          }
        }
      }
    }
    .timeframe-total-container {
      display: flex;
      width: 100%;
      height: 40px;
      margin-top: 3rem;
      margin-bottom: 3rem;
      .left-timeframe-total-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        .left-switch-timeframe-total-container {
          display: flex;
          .switch-total {
          }
          .text-total {
            margin-left: 1.5rem;
            //styleName: Text Reg 16;
            font-family: Prompt;
            font-size: 16px;
            font-weight: 400;
            line-height: 24.19px;
            text-align: left;
          }
        }
        .left-input-timeframe-total-container {
          display: flex;
          align-items: center;
          .input-total {
          }
          .text-input-total {
            margin-left: 1.5rem;
            //styleName: Text Reg 16;
            font-family: Prompt;
            font-size: 16px;
            font-weight: 400;
            line-height: 24.19px;
            text-align: left;
          }
        }
      }
    }
    .timeframe-avg-container {
      display: flex;
      width: 100%;
      height: 40px;
      .left-timeframe-avg-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        .left-switch-timeframe-avg-container {
          display: flex;
          .switch-avg {
          }
          .text-avg {
            margin-left: 1.5rem;
            //styleName: Text Reg 16;
            font-family: Prompt;
            font-size: 16px;
            font-weight: 400;
            line-height: 24.19px;
            text-align: left;
          }
        }
        .left-input-timeframe-avg-container {
          display: flex;
          align-items: center;
          .input-avg {
          }
          .text-input-avg {
            margin-left: 1.5rem;
            //styleName: Text Reg 16;
            font-family: Prompt;
            font-size: 16px;
            font-weight: 400;
            line-height: 24.19px;
            text-align: left;
          }
        }
      }
    }
  }
  .divider {
    margin-left: 2rem;
    margin-right: 2rem;
    width: 1px;
    height: 95%;
    background: #e2e2e2;
  }
  .right-timeframe-group {
    display: flex;
    width: 50%;
    .right-timeframe-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      .right-top-timeframe-container {
        display: flex;
        justify-content: space-between;
        .right-switch-timeframe-container {
          display: flex;
          .switch {
          }
          .text {
            margin-left: 1.5rem;
            //styleName: Text Med 16;
            font-family: Prompt;
            font-size: 16px;
            font-weight: 500;
            line-height: 24.19px;
            text-align: left;
          }
        }
        .right-dropdown-timeframe-container {
          display: flex;
        }
      }
      .right-bottom-timeframe-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-top: 2rem;
        .right-text-timeframe-container {
          display: flex;
          .text {
            //styleName: Text Reg 16;
            font-family: Prompt;
            font-size: 16px;
            font-weight: 400;
            line-height: 24.19px;
            text-align: left;
          }
        }
        .right-after-timeframe-container {
          display: flex;
          align-items: center;
          .input {
          }
          .dropdown {
            font-family: Prompt;
            font-size: 16px;
            font-weight: 400;
            line-height: 1;
            text-align: left;
            color: #2d2d2d;
            display: block;
            width: 100px;
            background-color: #fff;
            background-clip: padding-box;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
            letter-spacing: 0.031rem;
            margin-left: 1rem;
            border-radius: 10px;
            &:deep(.vs__dropdown-toggle) {
              border: 1px solid #e2e2e2;
              border-radius: 10px;
              height: 42px;
            }

            .vs__selected-options {
              position: relative;
              height: 100%;
            }

            .v-select {
              width: 100%;

              .vs__dropdown-toggle {
                height: 100%;

                .vs__selected {
                  position: absolute;
                  height: 100%;
                  margin: auto auto auto 0;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
